// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"69":"b6315e6a","275":"31ed11c0","453":"4c207b1e"}[chunkId] + ".chunk.js";
};